// Opening message and suggested questions for the AI Analyst.
export const AI_GREETING_INTRO = "Your job data is ready. Let's see what's working. I can show you your most profitable jobs, your best clients, the kinds of work that pay off most, and where there's room to grow.";
export const AI_GREETING_ASK = "Pick a question below or ask your own.";
// The demo answers only the suggested questions, so its greeting does not invite a typed one.
export const AI_GREETING_ASK_DEMO = "Pick a question below.";
export const AI_GREETING = AI_GREETING_INTRO + " " + AI_GREETING_ASK;

export const AI_GREETING_EXPENSES_LINE = "A few expenses still need a job. I'll point out where sorting them would sharpen the numbers.";

export const AI_SUGGESTIONS = [
  "Which jobs made me the most this year?",
  "Who are my most profitable clients?",
  "What kind of work pays off best?",
  "Where could I improve my margins?",
];

// Takes the data-quality summary. The expenses line shows only when at least
// one expense is actually unassigned (not just missing labor or costs).
export function aiGreeting(quality, demo = false) {
  const needsJob = !!quality && quality.unassignedCount > 0;
  const base = AI_GREETING_INTRO + " " + (demo ? AI_GREETING_ASK_DEMO : AI_GREETING_ASK);
  return base + (needsJob ? " " + AI_GREETING_EXPENSES_LINE : "");
}
